import styled from 'styled-components';
import { em } from 'polished';
import { appTheme } from '../../theme';

const DetailsLabel = styled.span`
  color: ${appTheme.system.black};
  display: block;
  font-size: ${em(16)};
  font-style: italic;
  font-weight: bold;
`;

export default DetailsLabel;



// WEBPACK FOOTER //
// ./src/modules/common/DetailsLabel.js